import { print } from 'graphql/language/printer';
import { fetchOk } from './fetch';
export const graphQLRequest = async (url, request) => {
  const {
    query: document,
    variables = null,
    operationName,
    skip = false
  } = request;
  if (skip) {
    return {
      data: undefined
    };
  }
  const fetchResponse = await fetchOk(url, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json'
    },
    body: JSON.stringify({
      operationName,
      query: print(document),
      variables
    })
  });
  const response = await fetchResponse.json();
  return response;
};